var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "minH",
    class: [_vm.$route.path != '/platform/search' && (_vm.$route.path === '/' || _vm.$route.path === '/platform') ? 'main_bg' : '', _vm.$route.path !== 'platform/search' && _vm.$route.path.match('/account/login') ? 'login_bg' : '']
  }, [_c('OrgCodeInput'), _c('div', {
    staticClass: "wrap"
  }, [_c('HubHeader'), _c('div', {
    class: [_vm.$route.path != '/platform' ? 'ptc_container' : '']
  }, [_c('router-view')], 1), _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('ul', {
    staticClass: "floating_btn"
  }), _c('div', {
    staticClass: "footer_cont"
  }, [_vm._m(0), _c('div', {
    staticClass: "align_lt"
  }, [_c('ul', {
    staticClass: "footer_link"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/terms',
        query: {
          type: 'PRIVACY'
        }
      }
    }
  }, [_vm._v("개인정보처리방침")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/terms',
        query: {
          type: 'TERM'
        }
      }
    }
  }, [_vm._v("플랫폼 이용약관")])], 1), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.handleClick
    }
  }, [_vm._v("공정도 작성")])]), _vm._m(1)]), _vm._m(2), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("COPYRIGHTⓒ2025 BY KIST ALL RIGHTS RESERVED")])])])])])], 1)], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('ul', {
    staticClass: "family_site align_rt"
  }, [_c('li', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://kist.re.kr/"
    }
  }, [_vm._v("KIST")])]), _c('li', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.kier.re.kr/"
    }
  }, [_vm._v("KIER")])])]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', [_c('a', {
    staticClass: "tutorial_down",
    attrs: {
      "href": "/m3dhub/tutorial/Hub_Manual.pdf",
      "target": "_blank",
      "download": ""
    }
  }, [_vm._v("튜토리얼 다운로드")])]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "address_tel"
  }, [_c('address', [_vm._v("[02792] 서울특별시 성북구 화랑로 14길 5")]), _c('span', [_vm._v("TEL : 02-958-5930")]), _c('span', [_vm._v("FAX : 02-958-5969/02-958-5969")])]);

}]

export { render, staticRenderFns }